import PerforationEditor from './Perforation'
export default PerforationEditor
